/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateSchoolCycleDto } from '../../models/amoxcalli-create-school-cycle-dto';
import { AmoxcalliSchoolCycleCreatedDto } from '../../models/amoxcalli-school-cycle-created-dto';

export interface ApiCyclesPost$Json$Params {
      body?: AmoxcalliCreateSchoolCycleDto
}

export function apiCyclesPost$Json(http: HttpClient, rootUrl: string, params?: ApiCyclesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliSchoolCycleCreatedDto>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliSchoolCycleCreatedDto>;
    })
  );
}

apiCyclesPost$Json.PATH = '/api/cycles';
